<template>
  <div class="home">
    <div
      class="carousel carousel-animated carousel-animate-slide"
      data-autoplay="true">
      <div class="carousel-container">
        <div class="carousel-item has-background is-active">
          <img
            class="is-background"
            src="../assets/img/vanhoutte.jpg"
            width="680"
            height="310">
        </div>
        <div class="carousel-item has-background">
          <img
            class="is-background"
            src="../assets/img/vanhoutte.jpg"
            width="680"
            height="310">
        </div>
      </div>
      <!-- <div class="carousel-navigation is-centered">
        <div class="carousel-nav-left">
          prev
        </div>
        <div class="carousel-nav-right">
          next
        </div>
      </div> -->
    </div>
    <div class="product-categories columns">
      <router-link
        v-for="productCategory in productCategories.categories"
        :to="'/producten/'+ productCategory.id + '/' + productCategory.title[0].text"
        :key="productCategory.id"
        class="column product-category">
        {{ productCategory.title[0].text }}
      </router-link>
    </div>
  </div>
</template>

<script>

import bulmaCarousel from "bulma-extensions/bulma-carousel/dist/js/bulma-carousel.min";
import { mapGetters, mapActions } from "vuex";


export default {
  name: "Home",
  data() {
    return {
      index: 1,
      carousel: []
    };
  },
  computed: {
    ...mapGetters({
      productCategories: "getProductCategories"
    })
  },
  created() {
    this.carousel = bulmaCarousel.attach();
    this.fetchProductCategories();
  },
  methods: {
    ...mapActions({
      fetchProductCategories: "fetchProductCategories"
    })
  }
};

</script>

<style scoped lang="scss">
@import "@/assets/css/style.scss";

.carousel .carousel-container .carousel-item {
  height: 65Vh;
}

.product-categories {
  margin-top: 20px;
}

.product-category {
  background-color: $secundary;
  text-align: center;
  padding: 20px;
  margin: 20px 20px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: 800;
  cursor: pointer;
}

</style>
